import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import NightlightIcon from '@mui/icons-material/Nightlight';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SunCalc from 'suncalc';

const AstroInfo = () => {
  const [astroData, setAstroData] = useState({
    location: 'NORTHUMBERLAND, ENG, GB',
    sunset: '',
    moonPhase: '',
    moonPercentage: 0
  });

  useEffect(() => {
    const updateAstroData = () => {
      // Northumberland coordinates (roughly centered on Alnwick)
      const lat = 55.4157;
      const lng = -1.7066;
      const date = new Date();

      // Calculate sun times
      const sunTimes = SunCalc.getTimes(date, lat, lng);
      const sunset = sunTimes.sunset;
      const sunsetTime = sunset.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      }).toUpperCase();

      // Calculate moon illumination
      const moonIllum = SunCalc.getMoonIllumination(date);
      const moonPercentage = Math.round(moonIllum.fraction * 100);

      // Determine moon phase
      let moonPhase = '';
      const phase = moonIllum.phase;
      if (phase <= 0.125 || phase > 0.875) moonPhase = 'NEW MOON';
      else if (phase <= 0.25) moonPhase = 'WAXING CRESCENT';
      else if (phase <= 0.375) moonPhase = 'FIRST QUARTER';
      else if (phase <= 0.625) moonPhase = 'WAXING GIBBOUS';
      else if (phase <= 0.75) moonPhase = 'FULL MOON';
      else if (phase <= 0.875) moonPhase = 'WANING GIBBOUS';
      else moonPhase = 'LAST QUARTER';

      setAstroData({
        location: 'NORTHUMBERLAND, ENG, GB',
        sunset: sunsetTime,
        moonPhase,
        moonPercentage
      });
    };

    updateAstroData();
    const interval = setInterval(updateAstroData, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        width: '100%'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LocationOnIcon sx={{ color: 'primary.light', fontSize: '0.875rem' }} />
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem',
            fontFamily: 'monospace',
            whiteSpace: 'nowrap'
          }}
        >
          {astroData.location}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WbTwilightIcon sx={{ color: 'primary.light', fontSize: '0.875rem' }} />
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem',
            fontFamily: 'monospace',
            whiteSpace: 'nowrap'
          }}
        >
          SUNSET: {astroData.sunset}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <NightlightIcon sx={{ color: 'primary.light', fontSize: '0.875rem' }} />
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem',
            fontFamily: 'monospace',
            whiteSpace: 'nowrap'
          }}
        >
          MOON: {astroData.moonPercentage}% {astroData.moonPhase}
        </Typography>
      </Box>
    </Box>
  );
};

export default AstroInfo;
